import styled from 'styled-components';

import { media, space, rems, getSectionGradient } from '../../ui/helpers';
import fonts from '../../ui/fonts';

const Module = styled.div<{ gradient: boolean }>`
  background: ${({ theme, gradient }) => (gradient ? getSectionGradient(theme) : theme.background)};
  padding: ${space(3)} 0;
  width: 100%;

  ${media.min('medium')`
    padding: ${space(8)} 0;
  `}
`;

const Top = styled.div`
  text-align: center;

  .title {
    margin: ${space(6)} 0;
  }

  ${media.min('medium')`
    .title {
      margin: ${space(8)} 0 ${space(7)} 0;
    }
  `}
`;

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 ${space(3)};
  justify-content: center;

  ${media.min('medium')`
    align-items: stretch;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0;
  `}
`;
const Card = styled.div`
  background: ${({ theme }) => theme.saturated};
  color: ${({ theme }) => theme.text};
  display: flex;
  flex-direction: column;
  margin-bottom: 2px;
  max-width: ${rems(560)};
  min-height: ${rems(350)};
  width: 100%;
  text-align: center;

  .textZone {
    padding: ${space(3)} ${space(3)} 0 ${space(3)};
    width: 100%;

    &_title {
      ${fonts.titleSM};
      margin-bottom: ${space(1)};
    }

    &_text {
      ${fonts.bodyMD};
      margin-bottom: ${space(3)};
    }
  }
  .btnWrapper {
    text-align: center;
    .btn {
      text-align: center;
      border: 2px solid ${({ theme }) => theme.text};
      color: ${({ theme }) => theme.text};
    }
  }

  .imageZone {
    display: flex;
    justify-content: center;
    margin-top: ${space(5)};
    width: 100%;

    &_image {
      width: 90%;
    }
  }

  ${media.min('medium')`
    margin: 1px;
    max-width: none;
    width: calc(50% - ${space(0.5)});



    .textZone {
      padding: ${space(6)} ${space(6)} 0 ${space(6)};
      width: 100%;

      &_title {
        margin-bottom: ${space(3)};
      }
    }

    .imageZone {
      margin-top: ${space(1)};

      &_image {
        align-items: flex-end;
        width: 100%;
      }
    }

    &:first-child:nth-last-child(2),
    &:first-child:nth-last-child(2) ~ &,
    &:nth-last-child(n) {
      .textZone {
        min-height: ${rems(265)};
      }

      .imageZone {
        &_image {
          width: 85%;
        }
      }
    }

    &:first-child:nth-last-child(1),
    &:first-child:nth-last-child(odd) {
      flex-direction: row;
      width: 100%;

      .textZone {
        width: 45%;
      }

      .imageZone {
        margin-top: 0;
        width: 55%;

        &_image {
          width: 100%;
        }
      }
    }

    &:nth-child(1):nth-last-child(3),
    &:nth-child(2):nth-last-child(2),
    &:nth-child(3):nth-last-child(1) {
      flex-direction: column;
      justify-content: space-between;
      min-height: ${rems(610)};
      width: calc(33.3333% - ${space(0.4)});
      flex: 1;

      .textZone {
        padding: ${space(4)} ${space(4)} 0 ${space(4)};
        width: 100%;
      }

      .imageZone {
        margin-top: ${space(1)};
        width: 100%;

        &_image {
          width: 90%;
        }
      }
    }

  `}
`;

export { Module, Top, Container, Card };
